import styled from 'styled-components';
import { LinkButton } from '../../../../../../common/components/Button/LinkButton/LinkButton';
import { Link } from '../../../../../../common/components/Link';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';
import { FontWeight } from '../../../../../../common/styles/constants';
import { onMobile } from '../../../../../../common/styles/onMobile';
import Icon from './AdInfoIcon.svg';

export const DisplayAd = styled.div`
  display: flex;
  position: relative;

  ${onMobile} {
    flex-direction: column;
  }
`;

export const StyledLink = styled(Link)`
  &:after {
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const Image = styled.div<{ src: string }>`
  background-image: url(${({ src }) => src});
  background-position: center;
  background-size: cover;
  margin-inline-end: 8px;
  overflow: hidden;
  width: 240px;

  ${onMobile} {
    margin-inline-end: 0;
    min-height: 152px;
    width: 100%;
  }
`;

export const ImageExpander = styled.div`
  padding-top: 44%;
  width: 100%;
`;

export const Copy = styled.div`
  align-items: start;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  position: relative;
`;

export const Logo = styled.img`
  height: 32px;
  max-width: 100%;
`;

export const Headline = styled.div`
  color: ${ThemeColours.black};
  font-size: 18px;
  font-weight: ${FontWeight.SEMI_BOLD};
  margin-top: 16px;
`;

export const Byline = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 14px;
  margin-top: 8px;
`;

export const SmallPrint = styled.div`
  color: ${ThemeColours.mono600};
  font-size: 12px;
  margin-top: 8px;
`;

export const AdLabel = styled.label`
  align-items: center;
  background-color: ${ThemeColours.mono100};
  border-radius: 2px;
  color: ${ThemeColours.mono600};
  display: flex;
  font-size: 0.7rem;
  line-height: 1rem;
  padding: 0.1rem 0.5rem;
  position: absolute;
  right: 16px;
  top: 16px;

  ${onMobile} {
    font-size: 0.8rem;
    padding: 0.3rem 0.7rem;
  }
`;

export const StyledIcon = styled(Icon)`
  height: 0.8rem;
  margin-inline-start: 0.1rem;
  width: 0.8rem;
`;

export const StyledButton = styled(LinkButton)<{ color?: string }>`
  background-color: ${({ color }) => color || ThemeColours.primary};
`;

export const ButtonContainer = styled.div`
  align-self: flex-end;
  margin-top: 24px;
`;
